import { render } from "./EventsSectionAbout.vue?vue&type=template&id=38589565"
import script from "./EventsSectionAbout.vue?vue&type=script&lang=js"
export * from "./EventsSectionAbout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__